module.exports = __webpack_public_path__ + "img/customer_communication.bbd8e366.svg";